import { useAuth } from "../hooks/useAuth";

export const usePermission = (moduleId: string, actionId: string): boolean => {
  const { getAvailableModules, isLoading } = useAuth();

  if (isLoading) return false;

  const modules = getAvailableModules();
  const module = modules.find((m: any) => m.moduleId === moduleId);
  return module?.moduleAction?.some((action: any) => action.actionId === actionId) ?? false;
};
